import { dateToTimeZone } from './dateToTimeZone';

export const checkIsToday = (dateForCheck: Date | Date[], timeZone: string) => {
  const currentDate = dateToTimeZone(new Date(), timeZone);

  const yearOfCurrentDate = currentDate.getFullYear();
  const monthOfCurrentDate = currentDate.getMonth();
  const dateOfCurrentDate = currentDate.getDate();
  
  if (Array.isArray(dateForCheck)) {
    return dateForCheck.some(date => {
      return (
        date.getFullYear() === yearOfCurrentDate &&
        date.getMonth() === monthOfCurrentDate &&
        date.getDate() === dateOfCurrentDate
      );
    });
  }
  else {
    return (
        dateForCheck.getFullYear() === yearOfCurrentDate &&
        dateForCheck.getMonth() === monthOfCurrentDate &&
        dateForCheck.getDate() === dateOfCurrentDate
    );
  }
};